export const constructProductUrl = (locale: string, productName: string, maId: string): string => {
  if (!locale || !productName || !maId) return '';
  return `/${locale}/${encodeURIComponent(productName)}-p-${maId}`;
};

export const getSearchParamFromUrl = (property: string) => {
  const params = new URL(window.location.href).searchParams;
  return params.get(property) || undefined;
};
